// Help-only int-backed enums, 1:1 with dotnet/Data/Trillion.Data/Enums/ArticleStatus.cs. The numeric
// values ARE the `article_status` lookup-table ids in the helpllm database — change one side, change both.
// Single-app, so this stays app-local; anything a second app consumes moves to @trillion/enums.

export enum ArticleStatus {
  Published = 1,
  Draft = 2,
  Archived = 3,
}
